export default __webpack_public_path__ + "static/media/kitchen3-afterK-1440w.e55a2a01.avif";